<template>
  <cargo-dialog
    ref="cargoDialog"
    custom-class="bill-payment-dialog-jc"
    :visible="visible"
    :title="title"
    width="960px"
    top="5vh"
    :can-maximize="source==='append'"
    :can-minimize="source==='append'"
    :source="source"
    class="grid-view"
    @close="cancel"
  >
    <div class="tabs-container">
      <el-tabs :active-name="activeTabName" @tab-click="handleClick">
        <el-tab-pane :label="$t('CargoMsg.Cargo_ApplicationForm')" name="applicationForm">
          <el-form :inline="true" style="width: 100%" label-width="75px" label-position="left" :disabled="readonly">
            <div style="display: flex;flex-direction: row;">
              <div style="flex: 1">
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('Payment.applicationNo')">
                    <el-input
                      v-model="billPayment.billPaymentNo"
                      no="1"
                      disabled="disabled"
                      style="width: 170px;"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Payment.status')" label-width="50px">
                    <span>{{ stateText }}</span>
                  </el-form-item>
                </div>
                <el-form-item :label="$t('Payment.settleAccountsTo')">
                  <div style="display: flex">
                    <cargo-advance-select
                      no="2"
                      filterable
                      :select-type="selectTypeNames.basic_data_Company"
                      :method-params="{customer:true}"
                      :default-value="Number(billPayment.accountId)||''"
                      style="width:170px;"
                      tag-name="chineseName"
                      disabled
                      @parentCallBack="p=>{billPayment.accountId=p.value;accountChange(p.value)}"
                    />
                    <div style="margin-left: 10px;display: flex; justify-content: space-between">
                      <el-checkbox v-model="agentChecked" no="3" :disabled="!readonly && this.settlementAgentArray.length == 0" @change="cbSettlementAgentChange">{{ $t('Payment.bySettlementAgent') }}</el-checkbox>
                      <cargo-advance-select
                        no="4"
                        filterable
                        :select-type="selectTypeNames.basic_data_Company"
                        :default-value="Number(billPayment.settlementAgentId) === 0 ? '' : Number(billPayment.settlementAgentId)"
                        :disabled="!agentChecked"
                        :cache="false"
                        tag-name="chineseName"
                        :static-options="settlementAgentArray"
                        style="margin-left: 10px"
                        @parentCallBack="p=>{billPayment.settlementAgentId=p.value;settlementAgentChange()}"
                      />
                    </div>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('Partners.paymentType')">
                  <div style="display: flex">
                    <cargo-advance-select
                      no="2"
                      filterable
                      :select-type="selectTypeNames.basic_data_PaymentType"
                      :default-value="billPayment.paymentType"
                      style="width:170px;"
                      tag-name="name"
                      @parentCallBack="p=>{billPayment.paymentType=p.value}"
                    />
                  </div>
                </el-form-item>
                <el-form-item :label="$t('Payment.businessType')">
                  <el-checkbox-group v-model="jobTypes" no="5" disabled>
                    <el-checkbox no="5a" label="SE">{{ $t('Payment.oceanExport') }}</el-checkbox>
                    <el-checkbox no="5b" label="SI">{{ $t('Payment.oceanImport') }}</el-checkbox>
                    <el-checkbox no="5c" label="AE">{{ $t('Payment.airExport') }}</el-checkbox>
                    <el-checkbox no="5d" label="AI">{{ $t('Payment.airImport') }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('Payment.currency')">
                    <cargo-advance-select
                      no="6"
                      style="width: 115px"
                      filterable
                      :clearable="false"
                      :select-type="selectTypeNames.basic_data_Currency"
                      :default-value="billPayment.currency"
                      @parentCallBack="p=>currencyChange(p.value)"
                    />
                  </el-form-item>
                  <el-form-item :label="rateLabel">
                    <num-input
                      v-model="billPayment.rate"
                      no="7"
                      :min="0"
                      :max="999999999"
                      :precision="8"
                      :truncated-precision="exchangeRatePrecision"
                      style="width: 120px;"
                      @change="rateChange"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Payment.amount')">
                    <el-input-number
                      v-model="billPayment.amount"
                      no="8"
                      :precision="2"
                      disabled
                      :controls="false"
                      style="width: 115px;"
                    />
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('Payment.paymentPeriod')">
                    <el-date-picker
                      v-model="billPayment.deadline"
                      no="9"
                      type="date"
                      clearable
                      style="width: 170px;"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Payment.methodOfPayment')">
                    <el-select v-model="billPayment.payType" no="10" style="width: 170px">
                      <el-option
                        v-for="(item,index) in receiveTypes"
                        :key="index"
                        :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                        :value="Number(item.code)"
                      />
                    </el-select>
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('Payment.invoiceHeader')">
                    <cargo-advance-select
                      no="28"
                      :allow-create="true"
                      :select-type="selectTypeNames.static_data_Title"
                      filterable
                      :cache="false"
                      :default-value="billPayment.invoiceTitle"
                      :static-options="titleArray"
                      style="width:170px;"
                      @parentCallBack="p=>{billPayment.invoiceTitle=p.value}"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Payment.bankAccount')">
                    <el-input
                      v-model="billPayment.buyerBankAccount"
                      no="12"
                      style="width:170px;"
                    />
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('Payment.bankOfDeposit')">
                    <cargo-advance-select
                      no="11"
                      filterable
                      :select-type="selectTypeNames.static_data_TitleBank"
                      :default-value="buyerBankUuid"
                      :cache="false"
                      :static-options="titleBankArray"
                      tag-value="uuid"
                      tag-name="bank"
                      style="width:170px;"
                      :headers="['币种', '银行名称']"
                      :fields="['currency', 'bank']"
                      @parentCallBack="titleBankChange"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Payment.dateOfApplication')">
                    <el-date-picker
                      v-model="billPayment.inputDate"
                      no="14"
                      type="date"
                      :clearable="false"
                      style="width:170px;"
                    />
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('Payment.applicant')">
                    <cargo-advance-select
                      no="13"
                      :select-type="selectTypeNames.basic_data_User"
                      :default-value="Number(billPayment.inputBy)||''"
                      style="width:170px;"
                      disabled
                    />
                  </el-form-item>
                </div>
                <div v-if="toExoSystemYGSH">
                  <el-form-item :label="$t('CargoMsg.Cargo_PaymentBranch')">
                    <el-select v-model="billPayment.settleDepartmentPrefix" no="15" style="width: 170px">
                      <el-option
                        v-for="(item,index) in paymentBranchType"
                        :key="index"
                        :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Remarks2')">
                    <el-select v-model="billPayment.recordType" no="16" style="width: 170px">
                      <el-option
                        v-for="(item,index) in sendRemarkTypes"
                        :key="index"
                        :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                        :value="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                      />
                    </el-select>
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('Payment.totalCurrency')">
                    <div style="width: 170px;">
                      <span>{{ billPayment.currencyAmount }}</span>
                    </div>
                  </el-form-item>
                  <el-form-item v-show="openSapConfig" :label="$t('Payment.settleDepartmentPrefix')">
                    <cargo-advance-select
                      no="17"
                      filterable
                      :select-type="selectTypeNames.basic_data_Department"
                      :default-value="billPayment.settleDepartmentPrefix || ''"
                      :cache="false"
                      :static-options="departmentArray"
                      style="width:170px;"
                      tag-name="chineseName"
                      tag-value="jobNoPrefix"
                      @parentCallBack="settleDepartmentPrefixChange"
                    />
                  </el-form-item>
                </div>
              </div>
              <div style="width: 290px;">
                <div class="el-form-item-wrapper">
                  <el-form-item label-width="0">
                    <span style="font-weight: bold;color:darkred;font-size: 14px;">{{ $t('Payment.couldNotSearhWriteOffJobFromThisWindow') }}</span>
                  </el-form-item>
                </div>
                <div v-if="toExoSystemYGSH" class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_ApplicationDetails')" label-width="100px" class="custom-textarea">
                    <el-input v-model="billPayment.sendRemark" no="18" type="textarea" :rows="5" style="width:290px;" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Remarks2')" label-width="100px" class="custom-textarea">
                    <el-input v-model="billPayment.remark" no="19" type="textarea" :rows="5" style="width:290px;" />
                  </el-form-item>
                </div>
                <div v-else class="el-form-item-wrapper">
                  <el-form-item :label="$t('Payment.remarks')" label-width="100px" class="custom-textarea">
                    <el-input v-model="billPayment.remark" no="20" type="textarea" :rows="12" style="width:290px;" />
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>
          <cargo-ag-grid
            config-module="190805"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            style="width:100%;height:100%;flex-grow: 1"
          />
          <div style="display: flex;justify-content: flex-end;margin-top:10px">
            <span>{{ $t('Payment.total') }}</span>
            <charge-currency-total-group
              :key="1"
              ar-field="chargeReceivable"
              data-field="chargeAmount"
              currency-field="chargeCurrency"
              rate-field="chargeRate"
              arap-order="ap"
              type="auto"
              :data-provider="rowData"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="billPayment.uuid" :label="$t('CargoMsg.Cargo_FileHistory')" name="fileHistory" :lazy="true" style="height: 503px;">
          <file-history :bill-payment-uuid="billPaymentUuid" :bill-payment-state="billPayment.state" :input-by="$store.getters.userId" :file-history-jc="true" grid-height="460px" />
        </el-tab-pane>
        <el-tab-pane v-if="billPayment.uuid" :label="$t('CargoMsg.Cargo_ApprovalHistory')" name="approvalList" :lazy="true" style="height: 503px;">
          <approval-history :bill-payment-uuid="billPaymentUuid" :approve-history-jc="true" style="width: 100%;" grid-height="503px" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div slot="footer" slot-scope="">
      <span v-if="billPayment.uuid && billPayment.state == 0 && step === 'step2' && mode === 'edit'" style="position: absolute; left: 20px;">
        <el-button v-show="activeTabName==='applicationForm' && billPayment.uuid && billPayment.state == 0" no="21" type="primary" @click="addCharge">{{ $t('Payment.addCharge') }}</el-button>
        <el-button v-show="activeTabName==='applicationForm' && billPayment.uuid && billPayment.state == 0" no="22" type="primary" @click="removeCharge">{{ $t('Payment.removeCharge') }}</el-button>
      </span>
      <span style="padding-right: 10px;">
        <el-button v-show="activeTabName==='applicationForm' && !billPayment.uuid && step === 'step2' && mode === 'edit'" no="23" type="primary" @click="toPreStep">{{ $t('Payment.back') }}</el-button>
        <el-button v-show="activeTabName==='applicationForm' && billPayment.uuid" no="24" type="primary" @click="doPrint">{{ $t('Payment.print') }}</el-button>
        <el-button v-show="activeTabName==='applicationForm' && billPayment.uuid && billPayment.state == 0" no="25" type="primary" @click="doCommit">{{ $t('Payment.submit') }}</el-button>
        <el-button v-show="activeTabName==='applicationForm'" no="26" type="primary" :disabled="readonly || btnSaveEnable" @click="doSave">{{ $t('Payment.save') }}</el-button>
        <el-button no="27" type="primary" @click="cancel">{{ $t('Payment.cancel') }}</el-button>
      </span>
    </div>
    <!--打印模板-->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <!--加入费用-->
    <join-charge-dialog
      v-if="joinChargeDialog.visible"
      :visible.sync="joinChargeDialog.visible"
      search-item-module="5043"
      :default-conditions="joinChargeDialog.addChargeCondition"
      charge-state-param="BillPaymentChargeState"
      @addChargeCallBackEvent="addChargeCallBack"
    />
  </cargo-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { BillPayment } from '@/class/model/act/BillPayment'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { formatNumberToThousands } from '@/utils'
import joinChargeDialog from '@/components/Cargo/Act/joinChargeDialog'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import URL from '@/api/urlTranslator'
import {
  queryBillPaymentDetail,
  queryChargeOfBillPayment,
  createBillPayment,
  updateBillPayment,
  updateBillPaymentState
} from '@/api/clearing/billPayment'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { allTitleBanksByCmpIdx, upsertPartnerTitleBank } from '@/api/partner/titleBank'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { getGridSelected } from '@/utils/agGrid'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import DateUtils from '@/utils/dateUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import { RMBBigTransForm } from '@/class/cargo/model/utils/RMBBigTransForm'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import fileHistory from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/fileHistory'
import approvalHistory from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/approvalHistory'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { getTitleByCmpIdxList } from '@/api/partner/title'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'

export default {
  name: 'BillPaymentDialogJc',
  components: { CargoDialog, cargoTemplateSelectorDialog, joinChargeDialog, cargoAdvanceSelect, chargeCurrencyTotalGroup, fileHistory, approvalHistory, NumInput },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: false, default: '查看付款申请单' },
    billPaymentUuid: { type: String, required: false, default: '' }, // 付款申请单Uuid
    isDirectPayment: { type: Boolean, required: false, default: false }, // 是否直达
    openSapConfig: { type: Boolean, required: false, default: false },
    toExoSystemYGSH: { type: Boolean, required: false, default: false }, // 阳光速航
    createSubmit: { type: Boolean, default: false }, // 创建完直接提交
    step: { type: String, default: 'step1' },
    source: { type: String, default: '' },
    mode: { type: String, default: 'edit' }, // 是否查看付款申请
    location: { type: String, required: false }
  },
  data() {
    return {
      fullscreen: false,
      minSize: false,
      billPayment: {},
      selectTypeNames: TYPE_NAMES,
      URL,
      agentChecked: 0, // 是否选中使用结算代理 1是 0否
      jobTypes: [],
      titleArray: [], // 抬头下拉数据源
      settlementAgentArray: [], // 结算代理数据源
      titleBankArray: [], // 开户银行数据源
      otherCurrencyArray: [], // 费用列表中与付款申请单币种不同的费用币种集合
      receiveTypes: ClearingConstants.AMOUNT_RECEIVE_TYPES, // 收付方式源
      sendRemarkTypes: SystemConstants.SEND_REMARK_TYPES, // 备案类型
      paymentBranchType: SystemConstants.PAYMENT_BRANCH_TYPE, // 支付分公司
      rateLabel: this.$t('Payment.exchangeRate'), // 汇率label
      gridOptions: {
        rowSelection: 'multiple',
        defaultColDef: {
          filter: false
        }
      },
      gridParams: {},
      gridApi: {},
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 5000
      },
      stateText: '', // 付款申请单状态
      templateSelectorDialog: { // 模板选择弹窗
        visible: false,
        cxt: null,
        category: 'BILLPAYMENT',
        data: {
          BILLPAYMENT_UUID: '',
          BILL_PAYMENT_UUID: ''
        }
      },
      joinChargeDialog: { // 加入费用弹窗
        visible: false,
        addChargeCondition: { // 点击加入费用按钮时传递的参数
          exceptKeys: [],
          hasBillPayment: -1,
          hasBilling: -1,
          oversea: -1,
          accountId: 0,
          viewSource: 'BillPaymentDetail_AddCharge' // 页面请求发起方
        }
      },
      isItACommercialAudit: false,
      departmentArray: [], // 付款申请结算公司数据源
      buyerBankUuid: '', // 开户银行虚拟字段，解决CARGO-12143问题
      activeTabName: 'applicationForm', // 当前展示页签
      existDistinctTitle: false,
      btnSaveEnable: false,
      defaultTitle: ''
    }
  },
  computed: {
    readonly() { // 付款申请单是否可编辑
      return this.billPayment && !!this.billPayment.uuid && this.billPayment.state !== '' && this.billPayment.state !== 0
    },
    // titleArray() { // 抬头下拉数据源
    //   const distinctTitleSet = new Set()
    //   const titles = []
    //   this.rowData.forEach(charge => {
    //     if (charge.chargeInvoiceTitle) {
    //       if (!distinctTitleSet.has(charge.chargeInvoiceTitle)) {
    //         distinctTitleSet.add(charge.chargeInvoiceTitle)
    //         titles.push({ 'title': charge.chargeInvoiceTitle })
    //       }
    //     }
    //   })
    //   if (distinctTitleSet.size > 1) {
    //     this.existDistinctTitle = true
    //   } else {
    //     this.existDistinctTitle = false
    //   }
    //   if (this.defaultTitle && !distinctTitleSet.has(this.defaultTitle)) {
    //     titles.push({ 'title': this.defaultTitle })
    //   }
    //   return titles
    // },
    columnDefs() {
      const self = this
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true, lockVisible: true
        },
        { headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: false,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'jobJobNo' },
              routeTitle: '财务审核',
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {}
            }
          },
          onCellClicked: (params) => {
            if (params.event.target.tagName === 'A') {
              self.$refs.cargoDialog.minSize = true
            }
          }
        },
        { headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        { headerName: this.$t('Payment.operation'), field: 'jobOp', width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        { headerName: this.$t('Payment.settlementCompany'), field: 'chargeAccountId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        { headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', width: 150,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.chargeItem'), field: 'chargeChargeItemId', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          } },
        { headerName: this.$t('Payment.currency'), field: 'chargeCurrency', width: 100 },
        { headerName: this.$t('Payment.paymentType'), field: 'chargeReceivable', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          } },
        { headerName: this.$t('Payment.SONO'), field: 'jobSoNo', width: 150,
          valueFormatter: (params) => {
            return params.value.replace(/\n/g, ',')
          }
        },
        { headerName: this.$t('Payment.mbl'), field: 'jobMbl', width: 150 },
        { headerName: this.$t('Payment.taxIncludedPrice'), field: 'chargeAmount', width: 150,
          cellRenderer: (params) => {
            return formatNumberToThousands(params.value, 2)
          } },
        { headerName: this.$t('Payment.taxExcludedPrice'), field: 'chargeExcludingTaxAmount', width: 150,
          cellRenderer: (params) => {
            return formatNumberToThousands(params.value, 2)
          } },
        { headerName: this.$t('Payment.taxAmount'), field: 'chargeTaxAmount', width: 150,
          cellRenderer: (params) => {
            return params.value === 0 ? '' : formatNumberToThousands(params.value, 2)
          } },
        { headerName: this.$t('Payment.taxRate'), field: 'chargeTaxRate', width: 150,
          cellRenderer: (params) => {
            return params.value === 0 ? '' : formatNumberToThousands(params.value, 2)
          }
        },
        { headerName: 'ETA', field: 'jobEta', width: 120, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ETD', field: 'jobEtd', width: 120, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ATD', field: 'jobAtd', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ATA', field: 'jobAta', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.chargeRemark'), field: 'chargeRemarks', width: 200 },
        {
          headerName: this.$t('FinanceManage.charge_payReceiveDate'),
          colId: 'chargePayReceiveDate',
          field: 'chargePayReceiveDate',
          width: 180,
          valueFormatter: params => {
            return DateUtils.formatStandardDate(params.value)
          },
          hide: true
        }, {
          headerName: this.$t('FinanceManage.charge_writeOffDate'),
          colId: 'chargeClearingDate',
          field: 'chargeClearingDate',
          width: 180,
          valueFormatter: params => {
            return DateUtils.formatStandardDate(params.value)
          },
          hide: true
        }
      ]
    },
    exchangeRatePrecision() {
      return CurrencyUtil.getCurrencyRateDigits(this.otherCurrencyArray.length > 0 ? this.otherCurrencyArray[0] : this.billPayment.currency)
    }
  },
  watch: {
    // 付款申请单状态
    'billPayment.state': {
      handler: function(val) {
        if (this.isItACommercialAudit && val && parseInt(val) === 2) {
          this.stateText = this.$t('CargoMsg.Cargo_OfficeApproved')
          return
        }
        const state = CommonState.getStateByCode(ClearingConstants.BILL_PAYMENT_STATES, Number(!val ? 0 : val))
        this.stateText = this.$store.getters.language === 'zh' ? state.chineseName : state.englishName
      },
      deep: true
    },
    //  结算代理
    'billPayment.settlementAgentId': {
      handler: function(val) {
        // 是否勾选结算代理复选框
        this.agentChecked = !!val
      },
      deep: true
    },
    // 结算对象
    'billPayment.accountId': {
      handler: function(val) {
        if (val > 0) {
          if (this.billPayment.settlementAgentId > 0) {
            const settlementAgent = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.billPayment.settlementAgentId))
            if (settlementAgent) {
              this.queryTitleBankList(Number(settlementAgent.cmpIdx))
            }
          } else {
            // 获取结算对象的开票抬头(一定要保证先查询开票抬头，然后再根据开票抬头去查询开票银行)
            this.queryTitleBankList(Number(val))
          }
          // 查询结算代理
          this.querySettlementAgentList(val)
        }
      },
      deep: true
    },
    // 分公司
    'billPayment.branchId': {
      handler: function(val) {
        if (val > 0) {
          const office = getObjectByCache(basicCacheKeys.basic_data_Office, 'officeId', Number(val))
          if (office) {
            const deps = getCacheListByKey(basicCacheKeys.basic_data_Department)
            if (deps && deps.length > 0) {
              this.departmentArray = deps.filter(dep => dep.officeUuid === office.uuid && (dep.jobNoPrefix && dep.jobNoPrefix !== ''))
            } else {
              this.departmentArray = []
            }
          }
        }
      },
      deep: true
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isItACommercialAudit = Number(cache.config.get('IsItACommercialAudit')) === 1
  },
  async beforeMount() {
    // 初始化保存按钮状态
    this.btnSaveEnable = false
    const billPaymentUuid = this.billPaymentUuid
    if (billPaymentUuid) { // 查看编辑付款申请单
      await this.queryBillPayment(billPaymentUuid)
    }
    this.checkChargeSameTitle()
    this.getTitleArray()
  },
  destroyed() {
    console.log('dialog-destroy', this)
  },
  methods: {
    // 初始化付款申请
    initBillPayment(charges = []) {
      if (!charges || charges.length === 0) return
      const billPayment = new BillPayment().fillDefaultValue().getData()
      this.rowData = charges
      const charge = charges[0]
      billPayment.branchId = this.$store.getters.currentOfficeId
      billPayment.inputBy = this.$store.getters.userInfo.userId
      billPayment.inputDate = new Date()
      billPayment.accountId = charge.chargeAccountId
      billPayment.state = 0
      billPayment.paymentType = '0'
      const state = CommonState.getStateByCode(ClearingConstants.BILL_PAYMENT_STATES, Number(billPayment.state))
      this.stateText = this.$store.getters.language === 'zh' ? state.chineseName : state.englishName
      let se = false
      let si = false
      let ae = false
      let ai = false
      this.jobTypes = []
      for (const charge of charges) {
        if (charge.jobLob && charge.jobLob === SystemConstants.SE.code) {
          se = true
          if (this.jobTypes.indexOf('SE') < 0) {
            this.jobTypes.push('SE')
          }
        }
        if (charge.jobLob && charge.jobLob === SystemConstants.SI.code) {
          si = true
          if (this.jobTypes.indexOf('SI') < 0) {
            this.jobTypes.push('SI')
          }
        }
        if (charge.jobLob && charge.jobLob === SystemConstants.AE.code) {
          ae = true
          if (this.jobTypes.indexOf('AE') < 0) {
            this.jobTypes.push('AE')
          }
        }
        if (charge.jobLob && charge.jobLob === SystemConstants.AI.code) {
          ai = true
          if (this.jobTypes.indexOf('AI') < 0) {
            this.jobTypes.push('AI')
          }
        }
      }
      billPayment.se = se
      billPayment.si = si
      billPayment.ae = ae
      billPayment.ai = ai
      billPayment.currency = charge.chargeCurrency
      // 付款方式默认为银行转账
      billPayment.payType = 2
      this.billPayment = billPayment
      this.querySettlementAgentList(billPayment.accountId)
      this.currencyChange(billPayment.currency)
      this.calCurrencyAmount()
    },
    // 查询付款申请
    async queryBillPayment(billPaymentUuid = null) {
      await queryBillPaymentDetail({ billPaymentUuid: billPaymentUuid, paging: false }).then(res => {
        this.billPayment = res.data
        if (this.billPayment.se) {
          this.jobTypes.push('SE')
        }
        if (this.billPayment.si) {
          this.jobTypes.push('SI')
        }
        if (this.billPayment.ae) {
          this.jobTypes.push('AE')
        }
        if (this.billPayment.ai) {
          this.jobTypes.push('AI')
        }
        this.queryChargeOfBillPayment(this.billPayment.uuid)
      })
      // await this.getTitleByCmpIdxList()
    },
    // 查询付款申请单关联的费用
    queryChargeOfBillPayment(billPaymentUuid = null) {
      const requestBody = { billPaymentUuid: billPaymentUuid, pageNum: this.pagination.pageNum, pageSize: this.pagination.pageSize, branchId: this.$store.getters.currentOfficeId }
      queryChargeOfBillPayment(requestBody).then(async res => {
        this.rowData = res.data.list ? res.data.list : []
        this.pagination.total = Number(res.data.total)
        await this.rateLabelChange(this.billPayment.currency, this.rowData, false)
      })
    },
    // 汇率标题修改事件
    async rateLabelChange(currency = '', charges = [], changeRate = false) {
      if (currency && charges && charges.length > 0) {
        const otherCurrencyArray = []
        for (const charge of charges) {
          const chargeCurrency = charge.chargeCurrency
          if (chargeCurrency && chargeCurrency !== this.billPayment.currency && otherCurrencyArray.indexOf(chargeCurrency) < 0) {
            otherCurrencyArray.push(chargeCurrency)
          }
        }
        if (otherCurrencyArray.length > 0) {
          this.rateLabel = otherCurrencyArray[0] + this.$t('Payment.exchangeRate')
          if (changeRate) {
            this.billPayment.rate = await RateUtil.getForeignExchangeRateSafely(this.billPayment.currency, otherCurrencyArray[0], new Date(), this.billPayment.branchId)
          }
        } else {
          this.rateLabel = this.$t('Payment.exchangeRate')
          this.billPayment.rate = 1.000000
        }
        this.otherCurrencyArray = otherCurrencyArray
      }
    },
    // 费用列表分页事件
    queryPageHandler() {
      if (this.billPaymentUuid) {
        this.queryChargeOfBillPayment(this.billPaymentUuid)
      }
    },
    async querySettlementAgentList(accountId) {
      const settlementAgentArray = await getSettlementAgentsByCmpIdx(accountId).then((res) => {
        return res.data
      })
      if (settlementAgentArray && settlementAgentArray.length > 0) {
        this.settlementAgentArray = settlementAgentArray
      } else {
        this.settlementAgentArray = []
      }
    },
    // 查询开户银行
    queryTitleBankList(accountId) {
      if (accountId > 0) {
        allTitleBanksByCmpIdx(accountId).then((res) => {
          if (res.data && res.data.length > 0 || (this.billPayment.buyerBank !== null && this.billPayment.buyerBank !== '')) {
            this.titleBankArray = res.data
            if (this.titleBankArray === null || this.titleBankArray === '') {
              this.titleBankArray = []
            }
            if (!this.titleBankArray.find(item => item.bank === this.billPayment.buyerBank && item.bankAccount === this.billPayment.buyerBankAccount)) {
              this.titleBankArray.push({ bank: this.billPayment.buyerBank, uuid: this.billPayment.uuid, bankAccount: this.billPayment.buyerBankAccount, currency: this.billPayment.currency })
            }
            if (!this.billPayment.uuid) { // 新增时
              for (const titleBank of this.titleBankArray) {
                if (titleBank.defaultBank && titleBank.title && titleBank.title.defaultTitle) {
                  this.billPayment.buyerBank = titleBank['bank']
                  this.billPayment.buyerBankAccount = titleBank['bankAccount']
                  this.buyerBankUuid = titleBank['uuid']
                  break
                }
              }
            } else {
              this.buyerBankUuid = ''
              for (const titleBank of this.titleBankArray) {
                if (titleBank.bank === this.billPayment.buyerBank && titleBank.bankAccount === this.billPayment.buyerBankAccount) {
                  this.buyerBankUuid = titleBank['uuid']
                  break
                }
              }
            }
          } else {
            this.titleBankArray = []
            this.billPayment.buyerBank = ''
            this.billPayment.buyerBankAccount = ''
            this.buyerBankUuid = ''
          }
        })
      }
    },
    // 结算对象变更事件
    accountChange(accountId) {
      if (!this.agentChecked && accountId) {
        this.queryTitleBankList(accountId)
      }
    },
    // 结算代理勾选框变更事件
    cbSettlementAgentChange() {
      if (this.agentChecked) {
        if (this.billPayment.settlementAgentId) {
          this.queryTitleBankList(this.billPayment.settlementAgentId)
        }
      } else {
        this.billPayment.settlementAgentId = 0
        if (this.billPayment.accountId) {
          this.queryTitleBankList(this.billPayment.accountId)
        }
      }
    },
    // 结算代理变更事件
    settlementAgentChange() {
      if (this.agentChecked && this.billPayment.settlementAgentId) {
        this.queryTitleBankList(this.billPayment.settlementAgentId)
      }
    },
    // 币种变更事件
    async currencyChange(currency = null) {
      if (currency) {
        this.billPayment.currency = currency
        await this.rateLabelChange(currency, this.rowData, true)
        await this.refreshAmount()
      }
    },
    // 结算公司变更事件
    settleDepartmentPrefixChange(dep) {
      if (dep) {
        this.billPayment.settleDepartmentPrefix = dep.jobNoPrefix ? dep.jobNoPrefix : ''
      } else {
        this.billPayment.settleDepartmentPrefix = ''
      }
    },
    // 刷新付款申请单金额
    async refreshAmount() {
      let amount = 0
      // CARGO-38807 H5 BUG 销账/付款申请单界面金额合计显示错误 付款金额
      const amountCurrencys = ChargeUtils.getZeroAmountCurrencys(this.rowData, 'chargeCurrency', 'chargeAmount', 'chargeReceivable')
      if (this.rowData && this.rowData.length > 0) {
        for (const charge of this.rowData) {
          if (amountCurrencys.includes(charge.chargeCurrency)) continue
          let rate = 1
          if (charge.chargeCurrency === this.billPayment.currency) {
            rate = 1
          } else if (charge.chargeCurrency === this.otherCurrencyArray[0]) {
            rate = isNaN(this.billPayment.rate) ? 0.00 : this.billPayment.rate
          } else {
            rate = await RateUtil.getForeignExchangeRateSafely(this.billPayment.currency, charge.chargeCurrency, new Date(), this.billPayment.branchId)
          }
          charge.chargeRate = rate
          if (charge.chargeReceivable) {
            // amount -= charge.chargeAmount * rate
            amount -= RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(charge.chargeAmount * rate, 2), this.billPayment.currency)
          } else {
            // amount += charge.chargeAmount * rate
            amount += RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(charge.chargeAmount * rate, 2), this.billPayment.currency)
          }
        }
      }
      // this.billPayment.amount = NumberUtils.ToFixed2(amount, 2)
      this.billPayment.amount = NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(amount, this.billPayment.currency), 2)
    },
    // 汇率变更事件
    rateChange() {
      this.refreshAmount()
    },
    // 开户银行变更事件
    titleBankChange(titleBank) {
      if (titleBank) {
        this.billPayment.buyerBank = titleBank['bank']
        this.billPayment.buyerBankAccount = titleBank['bankAccount']
        this.buyerBankUuid = titleBank['uuid']
      } else {
        this.billPayment.buyerBank = ''
        this.billPayment.buyerBankAccount = ''
        this.buyerBankUuid = ''
      }
    },
    // 加入费用
    async addCharge() {
      const keys = []
      if (this.rowData && this.rowData.length > 0) {
        for (const charge of this.rowData) {
          if (keys.indexOf(charge.uuid) < 0) {
            keys.push(charge.uuid)
          }
        }
      }
      this.joinChargeDialog.addChargeCondition.accountId = this.billPayment.accountId
      this.joinChargeDialog.addChargeCondition.hasBillPayment = 0
      this.joinChargeDialog.addChargeCondition.isShowWriteOff = 0
      this.joinChargeDialog.addChargeCondition.exceptKeys = keys
      this.joinChargeDialog.visible = true
    },
    // 加入费用回调函数
    addChargeCallBack(charges = []) {
      if (charges && charges.length > 0) {
        let chargesAdded = this.billPayment.chargesAdded
        const chargesRemoved = this.billPayment.chargesRemoved
        for (const charge of charges) {
          // 1.判断添加费用的集合是否存在，不存在则初始化变量
          if (!chargesAdded) {
            chargesAdded = []
          }
          const index = chargesAdded.findIndex(p => p.uuid === charge.uuid)
          if (index < 0) {
            chargesAdded.push({ uuid: charge.uuid, version: charge.version })
          }
          // 2.校验新添加的费用是否在移除的费用中，有则移除
          if (chargesRemoved && chargesRemoved.length > 0) {
            const delIndex = chargesRemoved.findIndex(p => p.uuid === charge.uuid)
            if (delIndex > -1) {
              chargesRemoved.slice(delIndex, 1)
            }
          }
        }
        this.billPayment.chargesAdded = chargesAdded
        this.billPayment.chargesRemoved = chargesRemoved
        // 更新费用列表
        this.rowData = this.rowData.concat(charges)
        // 重新计算付款申请金额以及分币种合计
        this.currencyChange(this.billPayment.currency)
        this.calCurrencyAmount()
        this.joinChargeDialog.visible = false
      }
    },
    // 移除费用
    removeCharge() {
      const charges = this.rowData
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
        return
      }
      if (charges.length === chooseRows.length) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CanNotRemovedAllCharge'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToRemoveTheExpenseItem', [chooseRows.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        for (const removedCharge of chooseRows) {
          const index = charges.findIndex(p => p.uuid === removedCharge.uuid)
          if (index > -1) {
            // 1.从费用明细列表中移除
            charges.splice(index, 1)
            // 2.是否有被移除的费用集合，没有则初始化变量
            if (!this.billPayment.chargesRemoved) {
              this.billPayment.chargesRemoved = []
            }
            const charge = {}
            charge.uuid = removedCharge.uuid
            charge.version = removedCharge.version
            // 3.先判断是否有进行过添加费用操作, 如果有，则移除掉。
            if (this.billPayment.chargesAdded && this.billPayment.chargesAdded.length > 0) {
              const addIndex = this.billPayment.chargesAdded.findIndex(p => p.uuid === charge.uuid)
              if (addIndex > -1) { // 如果有，则直接从chargesAdded移除
                this.billPayment.chargesAdded.splice(addIndex, 1)
              }
            }
            // 4. 判断删除的集合中是否包含本次移除的费用，如果没有，则添加到移除集合中。
            const delIndex = this.billPayment.chargesRemoved.findIndex(p => p.uuid === charge.uuid)
            if (removedCharge.billPaymentUuid) { // 已关联的付款申请
              if (delIndex < 0) {
                this.billPayment.chargesRemoved.push(charge)
              }
            } else { // 没有关联付款申请的，直接移除掉
              if (delIndex >= 0) {
                this.billPayment.chargesRemoved.splice(delIndex, 1)
              }
            }
          }
          this.currencyChange(this.billPayment.currency)
          this.calCurrencyAmount()
        }
      }).catch(() => {
      })
    },
    // 上一步
    toPreStep() {
      this.$emit('toPreStep', 'step1')
    },
    // 计算分币种合计
    calCurrencyAmount() {
      const charges = this.rowData
      let currencyAmount = ''
      if (charges && charges.length > 0) {
        const currencyMap = new Map()
        for (const charge of charges) {
          const chargeCurrency = charge.chargeCurrency
          const amount = isNaN(charge.chargeAmount) ? 0 : charge.chargeAmount
          const receivable = charge.chargeReceivable
          if (!receivable) {
            if (!currencyMap.has(chargeCurrency)) {
              currencyMap.set(chargeCurrency, amount)
            } else {
              const total = currencyMap.get(chargeCurrency)
              // currencyMap.set(chargeCurrency, total + amount)
              currencyMap.set(chargeCurrency, RateUtil.getAmountByCurrency(total + amount, chargeCurrency))
            }
          } else {
            if (!currencyMap.has(chargeCurrency)) {
              currencyMap.set(chargeCurrency, -amount)
            } else {
              const total = currencyMap.get(chargeCurrency)
              // currencyMap.set(chargeCurrency, total + (-amount))
              currencyMap.set(chargeCurrency, RateUtil.getAmountByCurrency(total + (-amount), chargeCurrency))
            }
          }
        }
        currencyMap.forEach(function(value, key) {
          // currencyAmount += key + ':' + NumberUtils.formatNumber(NumberUtils.ToFixed2(value, 2), 2) + ';'
          currencyAmount += key + ':' + NumberUtils.formatNumber(NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(value, key), 2), 2) + ';'
        })
      }
      this.billPayment.currencyAmount = currencyAmount
    },
    // 提交按钮触发事件
    doCommit() {
      if (this.billPayment.uuid && this.billPayment.version) {
        const keys = [{ uuid: this.billPayment.uuid, version: this.billPayment.version }]
        const state = this.isDirectPayment ? 2 : 1
        const params = {
          billPayments: keys,
          state: state,
          operation: 'commit'
        }
        updateBillPaymentState(params).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_SubmittedSuccessfully'))
          this.billPayment.state = state
          this.$emit('saveSuccess', [this.billPayment])
          return
        }).catch().finally()
      }
    },
    // 打印按钮触发事件
    doPrint() {
      this.templateSelectorDialog.data.BILLPAYMENT_UUID = this.billPayment.uuid
      this.templateSelectorDialog.data.BILL_PAYMENT_UUID = this.billPayment.uuid
      this.templateSelectorDialog.category = 'BILLPAYMENT'
      this.templateSelectorDialog.visible = true
    },
    // 取消事件
    cancel() {
      this.btnSaveEnable = false
      this.$emit('cancel')
      if (this.source === 'append') {
        if (this.destroySelf) {
          this.destroySelf()
        }
      }
    },
    // 保存
    async doSave() {
      this.btnSaveEnable = true
      const validate = await this.validateForm()
      if (!validate) {
        this.btnSaveEnable = false
        return
      }
      const upsertOk = await this.upsertPartnerTitleBankIfNeeded()
      if (!upsertOk) {
        this.btnSaveEnable = false
        return
      }
      const billPayment = this.billPayment
      this.billPayment.chineseAmount = RMBBigTransForm.toBigAmt(NumberUtils.ToFixed2(this.billPayment.amount, 2))
      if (!billPayment.settlementAgentId) {
        billPayment.settlementAgentId = 0
      }
      billPayment.branchId = this.$store.getters.currentOfficeId
      billPayment.singleRateView = true
      delete billPayment.currencyRateMap
      if (!billPayment.uuid) { // 新增
        billPayment.jobNo = ''
        billPayment.costInvoiceNo = ''
        billPayment.customerId = -1
        billPayment.inputBy = this.$store.getters.userInfo.userId
        // 随机取第一条费用，将相关属性设置到付款申请上
        this.setBillPaymentProperties(this.rowData[0])
        await this.checkAmountData(billPayment)
        if (this.existDistinctTitle) {
          this.$confirm(this.$t('Message.InvoiceHeaderDifferent'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
            this.createBillPayment(billPayment)
          }).catch(() => {}).finally(() => {
            this.btnSaveEnable = false
          })
        } else {
          this.createBillPayment(billPayment)
        }
      } else { // 更新
        if (billPayment.chargesRemoved) {
          let jobNoExist = false
          for (const charge of this.rowData) {
            if (billPayment.jobNo === charge.jobJobNo) {
              jobNoExist = true
              break
            }
          }
          // 若付款申请总不存在该业务编号，则重新将相关属性设置到付款申请上
          if (!jobNoExist) {
            this.setBillPaymentProperties2(this.rowData[0])
          }
        }
        for (const charge of this.rowData) {
          if (!charge.billPaymentUuid) {
            const map = {}
            map.uuid = charge.uuid
            map.version = charge.version
            if (!billPayment.chargesAdded) {
              billPayment.chargesAdded = []
              billPayment.chargesAdded.push(map)
            } else {
              const addIndex = billPayment.chargesAdded.findIndex(p => p.uuid === map.uuid)
              if (addIndex < 0) {
                billPayment.chargesAdded.push(map)
              }
            }
          }
        }
        delete billPayment.mapCharge
        delete billPayment.params
        if (!billPayment.chargesAdded) {
          delete billPayment.chargesAdded
        }
        if (!billPayment.chargesRemoved) {
          delete billPayment.chargesRemoved
        }
        await this.checkAmountData(billPayment)
        billPayment.inputByDep = this.$store.getters.currentDeptId
        if (this.existDistinctTitle) {
          this.$confirm(this.$t('Message.InvoiceHeaderDifferent'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
            this.updateBillPayment(billPayment)
          }).catch(() => {}).finally(() => {
            this.btnSaveEnable = false
          })
        } else {
          this.updateBillPayment(billPayment)
        }
      }
    },
    // 后端会根据参数 重新计算付款申请金额，与前端传递金额对比
    async checkAmountData(billPayment) {
      billPayment.mapCharge = []
      for (const charge of this.rowData) {
        const map = {}
        map.uuid = charge.uuid
        map.version = charge.version
        billPayment.mapCharge.push(map)
      }
      billPayment.params = {}
      await cache.load(cacheName.CONFIG)
      billPayment.params.isCheck = await Number(cache.config.get('isCheckBillPaymentAmount'))
      billPayment.params.otherCurrency = this.otherCurrencyArray && this.otherCurrencyArray.length > 0 ? this.otherCurrencyArray[0] : ''
      billPayment.params.txtRate = billPayment.rate
    },
    async upsertPartnerTitleBankIfNeeded() {
      const paymentType = this.billPayment && this.billPayment.paymentType
      if (paymentType === undefined || paymentType === null || paymentType === '') return true
      const typeName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentType, 'code', paymentType, 'name')
      if (typeName !== '日常付款申请' && typeName !== '月结付款申请') return true

      const invoiceTitle = this.billPayment && typeof this.billPayment.invoiceTitle === 'string' ? this.billPayment.invoiceTitle.trim() : this.billPayment.invoiceTitle
      if (!invoiceTitle) {
        this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [this.$t('Payment.invoiceHeader')]))
        return false
      }
      const bank = this.billPayment && typeof this.billPayment.buyerBank === 'string' ? this.billPayment.buyerBank.trim() : this.billPayment.buyerBank
      if (!bank) {
        this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [this.$t('Payment.bankOfDeposit')]))
        return false
      }
      const bankAccount = this.billPayment && typeof this.billPayment.buyerBankAccount === 'string' ? this.billPayment.buyerBankAccount.trim() : this.billPayment.buyerBankAccount
      if (!bankAccount) {
        this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [this.$t('Payment.bankAccount')]))
        return false
      }
      const companyId = Number(this.billPayment && this.billPayment.accountId)
      if (!companyId) {
        this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [this.$t('Payment.settleAccountsTo')]))
        return false
      }
      const currency = this.billPayment && typeof this.billPayment.currency === 'string' ? this.billPayment.currency.trim() : this.billPayment.currency
      const payload = { invoiceTitle, bank, bankAccount, companyId, currency }
      const loading = getLoading4Cxt(this)
      try {
        await upsertPartnerTitleBank(payload)
        return true
      } catch (e) {
        return false
      } finally {
        loading.close()
      }
    },
    // 校验付款申请单
    async validateForm() {
      if (!this.billPayment.currency) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectCurrency'))
        return false
      }
      if (this.rowData.length === 0) {
        this.$message.warning(this.$t('Message.PleaseAddCosts'))
        return false
      }
      if (!this.billPayment.deadline) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterPaymentTerm'))
        return false
      }
      if (this.openSapConfig && !this.billPayment.settleDepartmentPrefix) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DepartmentPrefixNotSelected'))
        return false
      }
      const aAmount = this.billPayment.amount
      const bAmount = await this.totalChargeAmount()
      if ((aAmount !== bAmount)) {
        this.$message.warning(this.$t('Message.ApplicationAmountCheck'))
        return false
      }
      if (this.rowData.length > 0) {
        let checkBranch = true
        let checkBranchId = true
        if (this.billPayment.branchId > 0) {
          checkBranchId = await SecurityUtil.checkChargeDetailBranch(this.billPayment.branchId)
        }
        for (let j = 0; j < this.rowData.length; j++) {
          checkBranch = await SecurityUtil.checkChargeDetailBranch(this.rowData[j].chargeBranchId)
          if (!checkBranch) {
            break
          }
        }
        if (!checkBranch && !checkBranchId) {
          this.$message.warning(this.$t('Message.CheckChargeDetailBranch'))
          return false
        }
      }
      return true
    },
    // 统计费用总金额
    async totalChargeAmount() {
      let amount = 0
      // CARGO-38807 H5 BUG 销账/付款申请单界面金额合计显示错误 付款金额
      const amountCurrencys = ChargeUtils.getZeroAmountCurrencys(this.rowData, 'chargeCurrency', 'chargeAmount', 'chargeReceivable')
      for (const charge of this.rowData) {
        if (amountCurrencys.includes(charge.chargeCurrency)) continue
        let rate = 1
        if (charge.chargeCurrency === this.billPayment.currency) {
          rate = 1
        } else if (this.otherCurrencyArray && this.otherCurrencyArray.length > 0 && charge.chargeCurrency === this.otherCurrencyArray[0]) {
          rate = this.billPayment.rate
        } else {
          rate = await RateUtil.getForeignExchangeRateSafely(this.billPayment.currency, charge.chargeCurrency, new Date(), this.billPayment.branchId)
        }
        this.chargeRate = rate
        if (charge.chargeReceivable) {
          // amount -= charge.chargeAmount * rate
          amount -= RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(charge.chargeAmount * rate, 2), this.billPayment.currency)
        } else {
          // amount += charge.chargeAmount * rate
          amount += RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(charge.chargeAmount * rate, 2), this.billPayment.currency)
        }
      }
      // return NumberUtils.ToFixed2(amount, 2)
      return NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(amount, this.billPayment.currency), 2)
    },
    setBillPaymentProperties(charge) {
      this.billPayment.advance = charge.chargeAdvance
      this.billPayment.accountId = charge.chargeAccountId
      if (!this.billPayment.jobNo) {
        this.billPayment.jobNo = charge.jobJobNo
      } else if (this.billPayment.jobNo !== charge.jobJobNo) {
        this.billPayment.jobNo = ''
      }
      if (!this.billPayment.costInvoiceNo && charge.chargeInvoiceNo) {
        this.billPayment.costInvoiceNo = charge.chargeInvoiceNo
      } else if (this.billPayment.costInvoiceNo !== charge.chargeInvoiceNo && charge.chargeInvoiceNo) {
        this.billPayment.costInvoiceNo = ''
      }
      if (Number('-1') === Number(this.billPayment.customerId)) {
        this.billPayment.customerId = charge.jobCustomerId
      } else if (this.billPayment.customerId > 0 && this.billPayment.customerId !== charge.jobCustomerId) {
        this.billPayment.customerId = 0
      }
    },
    /**
     * 更新付款申请时，若付款申请中业务单号对应的全被移除，则重设相关参数
     * @param charge
     */
    setBillPaymentProperties2(charge) {
      this.billPayment.advance = charge.chargeAdvance
      this.billPayment.accountId = charge.chargeAccountId
      if (charge.jobJobNo) {
        this.billPayment.jobNo = charge.jobJobNo
      } else {
        this.billPayment.jobNo = ''
      }
      if (charge.chargeInvoiceNo) {
        this.billPayment.costInvoiceNo = charge.chargeInvoiceNo
      } else {
        this.billPayment.costInvoiceNo = ''
      }
      if (Number('-1') === Number(this.billPayment.customerId)) {
        this.billPayment.customerId = charge.jobCustomerId
      } else {
        this.billPayment.customerId = 0
      }
    },
    // tab 页签点击事件
    handleClick(tab, event) {
      console.log(tab, event)
      this.activeTabName = tab.name
    },
    createBillPayment(billPayment) {
      const loading = getLoading4Cxt(this)
      billPayment.location = this.location
      createBillPayment(billPayment).then(res => {
        if (res.data) {
          this.billPayment = res.data
          if (!this.createSubmit) {
            this.$emit('reloadData')
            this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          } else {
            if (this.billPayment.uuid) {
              this.queryChargeOfBillPayment(this.billPayment.uuid)
            }
            this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          }
        } else {
          this.$message.error(this.$t('Clearing.CreatingFormFailedPleaseAgain'))
        }
      }).finally(() => {
        loading.close()
        this.btnSaveEnable = false
      })
    },
    updateBillPayment(billPayment) {
      const loading = getLoading4Cxt(this)
      billPayment.location = this.location
      updateBillPayment(billPayment).then(res => {
        if (res.data) {
          this.billPayment = res.data
          if (!this.createSubmit) {
            this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
            this.$emit('reloadData')
          } else {
            this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
          }
        }
      }).finally(() => {
        loading.close()
        this.btnSaveEnable = false
      })
    },
    // async getTitleByCmpIdxList() {
    //   const cmpIdxList = []
    //   cmpIdxList.push(this.billPayment.accountId)
    //   await getTitleByCmpIdxList(cmpIdxList).then(res => {
    //     const titles = res.data
    //     if (titles && titles.length > 0) {
    //       // 默认抬头取结算对象的默认抬头
    //       this.defaultTitle = titles[0].title
    //     } else {
    //       // 默认抬头取结算对象
    //       this.defaultTitle = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.billPayment.accountId, 'chineseName')
    //     }
    //   })
    // },
    async getTitleArray() {
      const titles = []
      await queryTitleByCpmIdx(this.billPayment.accountId).then(res => {
        const data = res.data
        if (data && data.length > 0) {
          data.forEach(title => {
            if (title.defaultTitle && !this.billPayment.invoiceTitle) {
              this.billPayment.invoiceTitle = title.title
            }
            titles.push({ 'title': title.title })
          })
          if (data.length === 1 && !this.billPayment.invoiceTitle) {
            this.billPayment.invoiceTitle = data[0].title
          }
        }
      })
      this.titleArray = titles
    },
    checkChargeSameTitle() {
      const distinctTitleSet = new Set()
      for (const charge of this.rowData) {
        if (charge.chargeInvoiceTitle) {
          if (distinctTitleSet.size > 0 && !distinctTitleSet.has(charge.chargeInvoiceTitle)) {
            this.existDistinctTitle = true
            break
          }
          distinctTitleSet.add(charge.chargeInvoiceTitle)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.el-dialog__wrapper{
  &.minSize {
    width: 250px;
    height: 60px;
    top:unset;
    left:unset;
    bottom:-20px;
    right: 0;
    .el-dialog {
      top:0;
      margin: 0!important;
    }
  }
}
.bill-payment-dialog-jc{
  display: flex;
  flex-direction: column;
  .custom-header{
    width:100%;display: flex;justify-content:space-between;
    span,i {
      font-size:16px
    }
  }
  .el-dialog__body{
    display: flex;
    flex-direction: column;
    flex:1;
    padding: 10px!important;
    .tabs-container {
      flex-grow: 1;
      .el-tabs {
        height: 100%;
        display: flex;
        flex-direction: column;
        .el-tabs__content {
          flex-grow: 1;
          .el-tab-pane {
            height: 100%;
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
  }
  .el-scrollbar__wrap {
    overflow-x: auto;
  }
  .custom-textarea {
    textarea {
      resize: none;
    }
  }
  .el-tabs__header {
    margin-bottom: 5px;
  }
}
</style>
